import request from '../utils/fetch'
export function getCommendGoodsList (data) {
  return request({
    url: '/admin/goods/getCommendGoodsList',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function commendGoodsSort (data) {
  return request({
    url: '/admin/goods/commendGoodsSort',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}
export function goods2NotRem (data) {
  return request({
    url: '/admin/goods/goods2NotRem',
    method: 'get',
    requestBody: 'query',
    loading: true,
    params: data
  })
}

